import { render, staticRenderFns } from "./receipt-preview.vue?vue&type=template&id=2bf7a1bb"
import script from "./receipt-preview.vue?vue&type=script&lang=js"
export * from "./receipt-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports